import { ZoidApp } from "../../../core/interfaces/zoid-app";
import { BehaviorSubject, Subject } from "rxjs";
import { Injectable } from "@angular/core";
import { LiveChatStateService } from "./live-chat-state.service";

@Injectable({ providedIn: 'root' })
export class AppBarService {
  private readonly currentAppsSub = new BehaviorSubject<ZoidApp[]>([]);
  public readonly currentApps$ = this.currentAppsSub.asObservable();
  private _currentApps: ZoidApp[] = [];

  constructor(private liveChatStateService: LiveChatStateService) {
    this.currentApps$.subscribe((apps) => {
      this._currentApps = apps;
    });
  }

  getCurrentApp() {
    return this._currentApps[this._currentApps.length - 1];
  }

  setCurrentApp(app: ZoidApp | undefined) {
    if (!app) {
      this.currentAppsSub.next([]);
      return;
    }
    const currentApps = this._currentApps.filter(currentApp => currentApp.id !== app.id);
    this.currentAppsSub.next([...currentApps, app]);
  }

  hide(appName: string) {
    const apps = this._currentApps.filter(app => app.name !== appName);
    this.currentAppsSub.next(apps);
    if (apps.length === 0) {
      this.liveChatStateService.setAppBarCollapsed(true);
    }
  }
}
